const io = require('socket.io-client');
const dishHelper = require('./dish-helper');
const orderDinnerHelper = require('./order-dinner-helper');
const config = require('../config');
const { formatMessage } = require('../intl/helper');
import errorMessages from '../intl/messages/error-message';

// soket 连接地址;
const SOCKET_URL = config.syncOrderDinnerSocketUrl;

// 事件常量定义
const CONNECT = 'connect';
const CONNECT_ERROR = 'connect_error';
const CONNECT_TIMEOUT = 'connect_timeout';

const JOIN_ROOM = 'join_room';
const CLOSE_ROOM = 'close_room';
const JOIN_ROOM_RESULT = 'join_room_result';
const CLOSE_ROOM_RESULT = 'close_room_result';

const CLEAN_ROOMS_ORDER = 'clean_rooms_order';
const CLEAN_ROOMS_ORDER_RESULT = 'clean_rooms_order_result';

const GET_SHOPPING_CART = 'get_shopping_cart';
const GET_SHOPPING_CART_RESULT = 'get_shopping_cart_result';
const CLOSE_ROOM_NOTICE = 'close_room_notice'; // 销房通知
const GET_ROOMS_INFO = 'get_rooms_info'; // 获取房间列表
const GET_ROOMS_INFO_RESULT = 'get_rooms_info_result'; // 获取房间列表结果
const GET_ORDER_CART = 'get_order_cart';
const GET_ORDER_CART_RESULT = 'get_order_cart_result';
const ORDER_DISH_NOTICE = 'order_dish_notice';
const ADD_ORDER_DISH = 'add_order_dish';
const ADD_ORDER_DISH_RESULT = 'add_order_dish_result';
const MINUS_ORDER_DISH = 'minus_order_dish';
const MINUS_ORDER_DISH_RESULT = 'minus_order_dish_result';
const ERROR = 'error';
const CLEAR_SHOPPINGCART = 'clear_shoppingcart';
const CLEAR_SHOPPINGCART_RESULT = 'clear_shoppingcart_result';
const CLEAR_SHOPPINGCART_NOTICE = 'clear_shoppingcart_notice';
const PLACE_ORDER = 'place_order';
const PLACE_ORDER_RESULT = 'place_order_result';
const PLACE_ORDER_NOTICE = 'place_order_notice';
const DISCONNECT = 'disconnect';
const HEART_BEATS = 'heartbeats_test';
const LOCK_PLACE_ORDER = 'lock_place_order';
const LOCK_PLACE_ORDER_RESULT = 'lock_place_order_result';

const MAX_NETWORK_DELAY_MILLISECOND = 500; // 网络延迟阈值(ms)，连续超出5次，客户端将提示 '当前网络环境差，请刷新后重试';
const RECONNECTION_DELAY = 5000; // 连接失败后延迟5S重连
const RECONNECTION_ATTEMPTS = 3; // 重连次数
const TIME_OUT = 60000;

class NetworkDelayMgr {
  maxSliceLength = 5;

  constructor(options) {
    Object.assign(this, options);

    this.timeSlices = [];
  }

  _appendSlice(slice) {
    if (this.timeSlices.length >= this.maxSliceLength) {
      this.timeSlices = [];
    }

    this.timeSlices.push(slice);
  }

  checkIsDelay(slice) {
    this._appendSlice(slice);

    if (this.timeSlices.length < this.maxSliceLength) {
      return false;
    }

    return this.timeSlices.every(timeSlice => timeSlice.end - timeSlice.start > MAX_NETWORK_DELAY_MILLISECOND);
  }
}
/**
 *  正餐Socket帮助类
 */
class DinnerSocketHelper {
  socket;

  userInfo;

  loopIndex = 3;

  isConnected = false;

  onBeforeInitDishes = null;

  onBeforeAddOrMinusDish = null;

  onBeforeJoinRoom = null;

  onAfterJoinRoom = null;

  onNetworkDelay = () => {};

  isJoinRoom = null;

  showDisconnectInfo = true;

  shoppingCartResultOwnerId = '';

  tableWay = '';

  connectionErrCount = 0; // 连接错误次数

  constructor(options = {}) {
    Object.assign(this, options);
    const reconnectionAttempts = options.reconnectionAttempts || RECONNECTION_ATTEMPTS;
    // this.socket = io(SOCKET_URL, { reconnectionDelay: 5000, timeout: 60000 });
    this.socket = io(SOCKET_URL, { reconnectionDelay: RECONNECTION_DELAY, timeout: TIME_OUT, reconnectionAttempts });
    if (options.onConnectError) {
      this.socket.on(CONNECT_ERROR, () => {
        this.connectionErrCount++;
        // console.log('---this.socket CONNECT_ERROR--', this.socket);
        // console.log('---this.socket this.connectionErrCount--', this.connectionErrCount);
        options.onConnectError(this.connectionErrCount);
      });
    }
    this.networkDelayMgr = new NetworkDelayMgr();
  }

  /**
   * 初始化socket
   *
   * @param userInfo
   */
  initSocket(userInfo, callback) {
    if (this.isConnected) {
      callback();
      return;
    }

    if (this.onBeforeJoinRoom) {
      this.onBeforeJoinRoom();
    }

    // this.socket.io.reconnect(); 此处需要修改

    this.socket.removeListener(CONNECT);
    this.socket.on(CONNECT, () => {
      this.joinRoom(userInfo, callback);
    });

    this.socket.removeListener(CONNECT_ERROR);
    this.socket.on(CONNECT_ERROR, error => {
      this.isConnected = false;
      if (this.onConnectError) {
        this.onConnectError();
      }
    });

    this.socket.removeListener(CONNECT_TIMEOUT);
    this.socket.on(CONNECT_TIMEOUT, info => {
      this.isConnected = false;
    });

    if (this.socket.connected) {
      this.joinRoom(userInfo, callback);
    } else {
      this.socket.connect();
    }

    this.socketIoHeartbeats(); // 建立心跳连接
  }

  socketIoHeartbeats() {
    let heartBeatTimeout = null;
    let hearBeatLock = null;
    let getMassageStatus = true; // 是否获取到信息
    let startTimestamp = null;

    const heartBeatBegin = () => {
      heartBeatTimeout = setTimeout(() => {
        // 心跳时间设置
        if (getMassageStatus && this.socket) {
          getMassageStatus = false;
          startTimestamp = Date.now();
          this.socket.emit(HEART_BEATS, JSON.stringify({ status: true })); // 3秒发送一次信息
        }

        hearBeatLock = setTimeout(() => {
          if (!getMassageStatus) {
            this.heartBeatReconnect();
          }
        }, 2000);
      }, 5000);
    };

    const heartBeatEnd = () => {
      if (this.networkDelayMgr.checkIsDelay({ start: startTimestamp, end: Date.now() })) {
        this.onNetworkDelay(formatMessage(errorMessages.networkFailTryRefresh));
      }

      getMassageStatus = true;
      clearTimeout(heartBeatTimeout);
      clearTimeout(hearBeatLock);
      heartBeatBegin();
    };

    this.heartBeatReconnect = () => {
      this.socket.connect();
      heartBeatEnd();
    };

    heartBeatBegin();
    this.socket.on(HEART_BEATS, msg => {
      heartBeatEnd();
    });
  }

  joinRoom(userInfo, callback) {
    this.socket.emit(JOIN_ROOM, userInfo);
    this.socket.removeListener(JOIN_ROOM_RESULT);
    if (this.isJoinRoomInterval) {
      clearInterval(this.isJoinRoomInterval);
    }
    // 加入房间监听事件
    this.socket.on(JOIN_ROOM_RESULT, joinRoomResult => {
      clearInterval(this.isJoinRoomInterval);
      if (joinRoomResult.success) {
        this.isConnected = true;
        // callback();

        if (this.onAfterJoinRoom) {
          this.onAfterJoinRoom();
        }

        callback();
        return;
      }
    });

    this.isJoinRoomInterval = setInterval(() => {
      this.showDisconnectInfo = false;
      this.socket.disconnect();
      this.socket.connect();
      this.initSocket(userInfo, callback);
      // 连接失败,重试
      /*
      if (this.loopIndex > 0) {
        this.loopIndex--;
        this.initSocket(userInfo, callback);
      } else {
        if (this.onAfterJoinRoom) {
          this.onAfterJoinRoom();
        }
      }
      */
    }, 3000);
  }

  cleanRoomOrder(orderList, callback) {
    this.socket.emit(CLEAN_ROOMS_ORDER, orderList);
    this.socket.removeListener(CLEAN_ROOMS_ORDER_RESULT);

    // 加入房间监听事件
    this.socket.on(CLEAN_ROOMS_ORDER_RESULT, cleanRoomResult => {
      if (cleanRoomResult.success) {
        // 成功退出房间
        callback();
      }
    });
  }

  closeRoom(userInfo, callback) {
    this.socket.compress(true).emit(CLOSE_ROOM, userInfo);
    this.socket.removeListener(CLOSE_ROOM_RESULT);

    // 加入房间监听事件
    this.socket.on(CLOSE_ROOM_RESULT, quitRoomResult => {
      if (quitRoomResult.success) {
        // 成功退出房间
        console.log('成功退出房间...');
      }
    });
  }

  noticeRoomInfo(_userInfo, callBack) {
    const doAction = () => {
      this.socket.emit(GET_ROOMS_INFO, _userInfo);
      this.socket.on(GET_ROOMS_INFO_RESULT, noticeResult => {
        callBack(noticeResult);
      });
    };
    if (this.socket.connected) {
      doAction();
    } else {
      this.socket.connect();
      this.socket.removeListener(CONNECT);
      this.socket.on(CONNECT, () => {
        doAction();
      });
    }
  }

  /**
   * place_order_notice事件
   *
   * @param callback
   */

  noticePlaceOrder(_userInfo, callBack) {
    const doAction = () => {
      this.socket.on(PLACE_ORDER_NOTICE, resultUserInfo => {
        callBack(resultUserInfo);
      });
    };
    if (this.socket.connected) {
      doAction();
    } else {
      this.socket.connect();
      this.socket.removeListener(CONNECT);
      this.socket.on(CONNECT, () => {
        doAction();
      });
    }
  }

  /**
   * 获取购物车数据
   *
   * @param callback
   */
  getShoppingCartEventInCart(callback, beforeCallback) {
    const doAction = () => {
      this.socket.emit(GET_SHOPPING_CART, this.userInfo);
      this.socket.removeListener(GET_SHOPPING_CART_RESULT);

      if (beforeCallback) {
        beforeCallback();
      }

      this.socket.on(GET_SHOPPING_CART_RESULT, shoppingCartResult => {
        const result = shoppingCartResult.chooseDishesResults.map(shoppingCartItem => {
          const { userInfo } = shoppingCartItem;
          const dishItems = shoppingCartItem.dishItems || [];

          if (this.onBeforeInitDishes) {
            this.onBeforeInitDishes(dishItems);
          }
          return {
            uuidTag: shoppingCartItem.uuidTag,
            userInfo,
            dishList: orderDinnerHelper.reconstructDishes(orderDinnerHelper.initializeDishes(dishItems)),
          };
        });
        this.shoppingCartResultOwnerId = shoppingCartResult.ownerId;
        callback(result || [], shoppingCartResult);
      });
    };

    this.initSocket(this.userInfo, doAction);
  }
  /**
   * 加减菜操作
   *
   * @param dishData 购车菜品信息
   * @param action   加减菜数量,如果是加菜传入正数,如果是减菜传入负数
   * @param callback  回调
   * @param userInfo 用户
   */
  addOrMinusDishEvent(dishData, action, callback, userInfo) {
    const orderUserInfo = userInfo || this.userInfo;
    const isOneTableOneBill = this.tableWay === 'oneTableOneBill'; // 一桌一单
    const doAction = () => {
      const orderDish = dishHelper.organizeDishData(dishData);
      if (this.onBeforeAddOrMinusDish) {
        this.onBeforeAddOrMinusDish(orderDish);
      }
      const actionArgs = {
        fromUser: Object.assign({}, orderUserInfo, { ownerId: isOneTableOneBill ? orderUserInfo.tableId : this.shoppingCartResultOwnerId }),
        toUser: orderUserInfo,
        orderDish,
      };
      orderDish.num = action;

      // 加减菜时判断是否保持连接 如果已经断开则重连
      if (!this.socket.connected) {
        this.socket.connect();
      }

      // 加菜
      if (action > 0) {
        this.socket.emit(ADD_ORDER_DISH, actionArgs);
        this.socket.removeListener(ADD_ORDER_DISH_RESULT);
        this.socket.on(ADD_ORDER_DISH_RESULT, addDishResult => {
          if (callback) {
            callback(addDishResult.success);
          }
        });
        return;
      }

      // 减菜
      if (action < 0) {
        this.socket.emit(MINUS_ORDER_DISH, actionArgs);
        this.socket.removeListener(MINUS_ORDER_DISH_RESULT);
        this.socket.on(MINUS_ORDER_DISH_RESULT, minusDishResult => {
          if (callback) {
            callback(minusDishResult.success);
          }
        });
      }
    };

    this.initSocket(this.userInfo, doAction);
  }

  /**
   * 菜品通知事件监听
   *
   * @param callback
   */
  dishNoticeListener(callback) {
    this.socket.on(ORDER_DISH_NOTICE, noticeResult => {
      const { fromUser, orderDish } = noticeResult;
      const userInfo = Object.assign({ addOperation: noticeResult.addOperation }, fromUser);
      const orderedDishes = [orderDish];
      if (this.onBeforeInitDishes) {
        this.onBeforeInitDishes(orderedDishes);
      }

      const orderData = orderDinnerHelper.reconstructDishes(orderDinnerHelper.initializeDishes(orderedDishes));
      const result = { userInfo, orderData };
      callback(result, orderDish.dishIncreaseUnit, orderDish.num, orderDish.stepNum);
    });
  }

  /**
   * 清空购物车监听
   *
   * @param callback
   */
  clearShoppingcartListener(callback) {
    this.socket.on(CLEAR_SHOPPINGCART_NOTICE, clearNoticeResult => {
      this.isConnected = false;
      // 清空购物车时判断是否保持连接 如果已经断开则重连
      if (!this.socket.connected) {
        this.socket.connect();
      }
      callback(clearNoticeResult);
    });
  }

  /**
   * 清空购物车事件
   *
   * @param callback
   */
  clearShoppingcartEvent(callback) {
    const doAction = () => {
      const userInfo = Object.assign({ clearType: 'DEFAULT' }, this.userInfo);

      this.socket.emit(CLEAR_SHOPPINGCART, userInfo);
      this.socket.removeListener(CLEAR_SHOPPINGCART_RESULT);
      this.socket.on(CLEAR_SHOPPINGCART_RESULT, clearShoppingcartResult => {
        if (callback) {
          callback(clearShoppingcartResult.success);
        }
      });
    };

    this.initSocket(this.userInfo, doAction);
  }

  /**
   * 获取购物车订单事件
   *
   * @param callback
   */
  getOrderCartEvent(callback) {
    const doAction = () => {
      // console.log('getOrderCartEvent calling');
      this.socket.emit(GET_ORDER_CART, this.userInfo);
      this.socket.removeListener(GET_ORDER_CART_RESULT);
      this.socket.on(GET_ORDER_CART_RESULT, result => {
        // console.log('getOrderCartEvent called');
        if (callback) {
          callback(result);
        }
      });
    };

    this.initSocket(this.userInfo, doAction);
  }

  /**
   * 提交订单事件
   *
   * @param callback
   */
  submitOrderEvent(orderedId, callback) {
    const isOneTableOneBill = this.tableWay === 'oneTableOneBill'; // 一桌一单
    const doAction = () => {
      const userInfo = Object.assign({}, this.userInfo, {
        clearType: 'ORDER_SUCCESS',
        orderId: orderedId,
        ownerId: isOneTableOneBill ? this.userInfo.tableId : this.shoppingCartResultOwnerId || this.userInfo.userId,
      });

      this.socket.emit(PLACE_ORDER, userInfo);
      this.socket.removeListener(PLACE_ORDER_RESULT);
      this.socket.on(PLACE_ORDER_RESULT, () => {
        this.socket.emit(CLEAR_SHOPPINGCART, userInfo);
        this.socket.removeListener(CLEAR_SHOPPINGCART_RESULT);
        this.socket.on(CLEAR_SHOPPINGCART_RESULT, clearShoppingcartResult => {
          if (callback) {
            callback(clearShoppingcartResult.success);
          }
        });
      });
    };

    this.initSocket(this.userInfo, doAction);
  }

  /**
   * 派发 LOCK_PLACE_ORDER 事件
   * @param {String} shoppingcartTag
   * @param {function} callback
   */
  emitLockPlaceOrderEvent(shoppingcartTag, callback = () => {}) {
    const doAction = () => {
      const { userInfo } = this;

      this.socket.emit(LOCK_PLACE_ORDER, {
        userInfo,
        shoppingcartTag,
      });

      this.socket.removeListener(LOCK_PLACE_ORDER_RESULT);
      this.socket.on(LOCK_PLACE_ORDER_RESULT, callback);
    };

    this.initSocket(this.userInfo, doAction);
  }

  /**
   * 异常事件
   *
   * @param callback
   */
  errorListener(callback, callbackCloseRoomNotice) {
    this.socket.on(ERROR, error => {
      callback(error);
    });
    this.socket.on(DISCONNECT, info => {
      if (this.showDisconnectInfo) {
        // 不提示用户断开连接
        // callback(formatMessage(errorMessages.disconnected));
      } else {
        this.showDisconnectInfo = true;
      }
    });
    setTimeout(() => {
      if (this.socket && this.socket.io.readyState === 'closed') {
        // 不提示用户断开连接
        // callback(formatMessage(errorMessages.errorAndReconnect));
      }
    }, RECONNECTION_DELAY);

    // 销房通知
    this.socket.on(CLOSE_ROOM_NOTICE, msg => {
      callbackCloseRoomNotice(msg);
    });
  }

  reconnect() {
    this.socket.io.reconnect();
  }

  close() {
    if (this.socket) {
      this.socket.destroy();
    }
  }
}

module.exports = DinnerSocketHelper;



// WEBPACK FOOTER //
// ./src/helper/socket-helper.js